import classNames from 'classnames';
import React from 'react';

import {TooltipPlacement, TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  buttonStyle: ButtonStyle;
  className?: string;
  disabled?: boolean;
  size?: ButtonSize;
  tooltipTitle?: string | null;
  onClick: () => void;
}

export default function ExecuteButton({
  buttonStyle,
  className,
  disabled = false,
  size = ButtonSize.SMALL,
  tooltipTitle,
  onClick,
}: Props): JSX.Element {
  return (
    <TooltipWrapper tooltipTitle={tooltipTitle} tooltipPlacement={TooltipPlacement.BOTTOM}>
      <div className={classNames('u-display-inline-block', className)}>
        <Button
          buttonStyle={buttonStyle}
          disabled={disabled}
          onClick={onClick}
          size={size}
          text="Execute"
          dataTestAttrs={{
            component: 'ExecuteButton',
            element: 'root',
          }}
        />
      </div>
    </TooltipWrapper>
  );
}
